import { getEthereumAddress, getInjectiveAddress } from "@ninjablaze/sdk-ts"
import { tryCatch } from "./trycatch"

const getAddress = (address: string) => {
  const ethAddress = tryCatch(() => getInjectiveAddress(getEthereumAddress(address)))
  if (ethAddress.error) {
    return undefined
  }
  return ethAddress.data;
}

export const getAnonymousUserName = (address: string, prefix = "Ninja-") => {
  const injectiveAddress = getAddress(address)
  if (injectiveAddress) {
    return prefix + getEthereumAddress(address).slice(-4)
  }
  return address
}